/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 残席数の選択肢表示種別
 */
export type FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType = 'visible' | 'hidden';

export const FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType = {
    Visible: 'visible' as FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType,
    Hidden: 'hidden' as FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType
};

